var render, staticRenderFns
import script from "./MeetingGroup.vue?vue&type=script&lang=js&"
export * from "./MeetingGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4695436",
  null
  
)

export default component.exports